import React from "react";

export interface ModalFooterProps {
  className?: string;
  children: React.ReactNode;
}

const ModalFooter: React.FC<ModalFooterProps> = ({ className = "", children }) => {
  return (
    <div className={`flex justify-end gap-3 p-6 border-t border-zinc-800 ${className}`}>
      {children}
    </div>
  );
};

export default ModalFooter;
